var map = {
	"./365-fa-logo-extended.svg": 3081,
	"./365-logo-brand.svg": 3082,
	"./365-logo-extended.svg": 2985,
	"./365-logo-premium-gradient.svg": 2092,
	"./365-logo-premium2.svg": 2203,
	"./365-logo-premium3.svg": 3083,
	"./365-logo-sm.svg": 2093,
	"./365-logo.svg": 2055,
	"./CaretRight.svg": 3084,
	"./arrow-right.svg": 498,
	"./autosave.svg": 2094,
	"./calculator-arrow.svg": 1736,
	"./campaign-stars-rating.svg": 2717,
	"./caret-left-circle-outline.svg": 3085,
	"./caret-left-circle.svg": 508,
	"./caret-right-circle-outline.svg": 3086,
	"./caret-right-circle.svg": 509,
	"./caret-right-white.svg": 2718,
	"./caret-right.svg": 591,
	"./carret-down-flashcards.svg": 2719,
	"./carret-down.svg": 2720,
	"./certificate-badge.svg": 2087,
	"./check.svg": 3087,
	"./checkout-minus-icon.svg": 2687,
	"./checkout-plus-icon.svg": 2688,
	"./close-icon.svg": 515,
	"./companies/campaign-logo-alphabet.svg": 609,
	"./companies/campaign-logo-amazon.svg": 610,
	"./companies/campaign-logo-meta.svg": 611,
	"./companies/campaign-logo-oracle.svg": 612,
	"./companies/campaign-logo-walmart.svg": 613,
	"./companies/logo-alphabet.svg": 573,
	"./companies/logo-amazon-2.svg": 574,
	"./companies/logo-amazon.svg": 614,
	"./companies/logo-azercell.svg": 615,
	"./companies/logo-bank-of-america.svg": 616,
	"./companies/logo-barclays.svg": 617,
	"./companies/logo-bbc.svg": 618,
	"./companies/logo-bloomberg.svg": 575,
	"./companies/logo-bnp-paribas.svg": 619,
	"./companies/logo-booking.svg": 620,
	"./companies/logo-citibank.svg": 621,
	"./companies/logo-cnbc.svg": 576,
	"./companies/logo-cnbc2.svg": 622,
	"./companies/logo-coca-cola-auto.svg": 572,
	"./companies/logo-coca-cola-white.svg": 1640,
	"./companies/logo-coca-cola.svg": 623,
	"./companies/logo-deloitte.svg": 624,
	"./companies/logo-experian.svg": 625,
	"./companies/logo-facebook.svg": 626,
	"./companies/logo-forbes.svg": 577,
	"./companies/logo-g.svg": 1641,
	"./companies/logo-goldman-sachs-new.svg": 627,
	"./companies/logo-goldman-sachs.svg": 1492,
	"./companies/logo-google-new.svg": 628,
	"./companies/logo-google.svg": 629,
	"./companies/logo-h.svg": 630,
	"./companies/logo-henkel.svg": 631,
	"./companies/logo-hsbc-new.svg": 632,
	"./companies/logo-hsbc.svg": 1490,
	"./companies/logo-ikea-new.svg": 633,
	"./companies/logo-ikea.svg": 1642,
	"./companies/logo-infineon.svg": 634,
	"./companies/logo-instagram-icon.svg": 570,
	"./companies/logo-instagram.svg": 635,
	"./companies/logo-jp-morgan.svg": 636,
	"./companies/logo-jti.svg": 637,
	"./companies/logo-linkedin.svg": 638,
	"./companies/logo-meta-new.svg": 569,
	"./companies/logo-meta.svg": 1593,
	"./companies/logo-morgan-stanley-new.svg": 639,
	"./companies/logo-morgan-stanley.svg": 1491,
	"./companies/logo-netflix.svg": 1488,
	"./companies/logo-oracle.svg": 578,
	"./companies/logo-paypal.svg": 640,
	"./companies/logo-pwc-new.svg": 571,
	"./companies/logo-pwc.svg": 1643,
	"./companies/logo-spotify.svg": 1489,
	"./companies/logo-tesla.svg": 641,
	"./companies/logo-usa-today.svg": 579,
	"./companies/logo-visa.svg": 642,
	"./companies/logo-walmart.svg": 580,
	"./companies/logo-wsj.svg": 581,
	"./companies/logo-youtube.svg": 643,
	"./courses/arrow-right.svg": 2056,
	"./courses/audience-icon.svg": 1962,
	"./courses/certificate-of-achievement.svg": 2057,
	"./courses/check-icon.svg": 1963,
	"./courses/clock-colored.svg": 1476,
	"./courses/clock.svg": 1784,
	"./courses/closed-captions.svg": 2058,
	"./courses/course-exam.svg": 2059,
	"./courses/curriculum-icon.svg": 1964,
	"./courses/downloadable-resources.svg": 2060,
	"./courses/fire.svg": 2061,
	"./courses/future-course-updates.svg": 2062,
	"./courses/hours-of-content.svg": 2063,
	"./courses/icon-book.svg": 1965,
	"./courses/icon-label-bestseller.svg": 600,
	"./courses/icon-label-free.svg": 601,
	"./courses/icon-label-new.svg": 602,
	"./courses/icon-label-popular.svg": 603,
	"./courses/icon-label-top-rated.svg": 604,
	"./courses/icon-label-trending.svg": 605,
	"./courses/icon-lesson-type.svg": 1785,
	"./courses/icon-people.svg": 1966,
	"./courses/icon-star.svg": 1967,
	"./courses/icon-text-lesson-type.svg": 1786,
	"./courses/instructors-icon.svg": 1968,
	"./courses/interactive-exercises-lg.svg": 1969,
	"./courses/interactive-exercises.svg": 1970,
	"./courses/medal-colored.svg": 2064,
	"./courses/medal.svg": 1732,
	"./courses/monitor-colored.svg": 2065,
	"./courses/monitor.svg": 1433,
	"./courses/overview-icon.svg": 1971,
	"./courses/play-circle.svg": 2066,
	"./courses/play.svg": 2067,
	"./courses/practical-tasks-colored.svg": 2068,
	"./courses/practical-tasks.svg": 2069,
	"./courses/projects-icon.svg": 1972,
	"./courses/q-and-a-support.svg": 2070,
	"./courses/replay.svg": 2071,
	"./courses/requirements-icon.svg": 1973,
	"./courses/reviews-icon.svg": 1974,
	"./courses/rocket-icon.svg": 1975,
	"./courses/similar-courses-icon.svg": 1976,
	"./courses/tags-icon.svg": 1977,
	"./courses/topics-icon.svg": 1978,
	"./courses/tracks-icon.svg": 1979,
	"./courses/what-you-learn.svg": 1980,
	"./courses/world-class-instructor.svg": 2072,
	"./curved-arrow.svg": 1787,
	"./editor-js/ejs-edit.svg": 1737,
	"./editor-js/ejs-hover-icon-delete.svg": 3088,
	"./editor-js/ejs-hover-icon-move-down.svg": 3089,
	"./editor-js/ejs-hover-icon-move-up.svg": 3090,
	"./editor-js/ejs-icon-code.svg": 1981,
	"./editor-js/ejs-icon-delete.svg": 1982,
	"./editor-js/ejs-icon-equation.svg": 1983,
	"./editor-js/ejs-icon-highlight.svg": 1984,
	"./editor-js/ejs-icon-info.svg": 1985,
	"./editor-js/ejs-icon-move-down.svg": 1986,
	"./editor-js/ejs-icon-move-up.svg": 1987,
	"./editor-js/ejs-icon-spoiler.svg": 1988,
	"./editor-js/ejs-icon-text.svg": 1989,
	"./editor-js/ejs-icon-warning.svg": 1990,
	"./editor-js/link-template/article-background.svg": 3091,
	"./editor-js/link-template/bookmark-background.svg": 3092,
	"./editor-js/link-template/other-background.svg": 3093,
	"./editor-js/link-template/video-background.svg": 3094,
	"./editor-js/link-template/website-background.svg": 3095,
	"./editor-resize-handle.svg": 3096,
	"./editor/bold.svg": 3097,
	"./editor/emoji.svg": 3098,
	"./editor/image.svg": 3099,
	"./editor/italic.svg": 3100,
	"./editor/language-arrow-editor-rotate.svg": 3101,
	"./editor/language-arrow-editor.svg": 3102,
	"./editor/link.svg": 3103,
	"./editor/underline.svg": 3104,
	"./equation/icon-equation-accent-1.svg": 2204,
	"./equation/icon-equation-accent-10.svg": 2205,
	"./equation/icon-equation-accent-11.svg": 2206,
	"./equation/icon-equation-accent-12.svg": 2207,
	"./equation/icon-equation-accent-13.svg": 2208,
	"./equation/icon-equation-accent-14.svg": 2209,
	"./equation/icon-equation-accent-15.svg": 2210,
	"./equation/icon-equation-accent-16.svg": 2211,
	"./equation/icon-equation-accent-17.svg": 2212,
	"./equation/icon-equation-accent-18.svg": 2213,
	"./equation/icon-equation-accent-19.svg": 2214,
	"./equation/icon-equation-accent-2.svg": 2215,
	"./equation/icon-equation-accent-20.svg": 2216,
	"./equation/icon-equation-accent-21.svg": 2217,
	"./equation/icon-equation-accent-22.svg": 2218,
	"./equation/icon-equation-accent-3.svg": 2219,
	"./equation/icon-equation-accent-4.svg": 2220,
	"./equation/icon-equation-accent-5.svg": 2221,
	"./equation/icon-equation-accent-6.svg": 2222,
	"./equation/icon-equation-accent-7.svg": 2223,
	"./equation/icon-equation-accent-8.svg": 2224,
	"./equation/icon-equation-accent-9.svg": 2225,
	"./equation/icon-equation-accent.svg": 2226,
	"./equation/icon-equation-bracket-1.svg": 2227,
	"./equation/icon-equation-bracket-10.svg": 2228,
	"./equation/icon-equation-bracket-11.svg": 2229,
	"./equation/icon-equation-bracket-12.svg": 2230,
	"./equation/icon-equation-bracket-13.svg": 2231,
	"./equation/icon-equation-bracket-14.svg": 2232,
	"./equation/icon-equation-bracket-15.svg": 2233,
	"./equation/icon-equation-bracket-16.svg": 2234,
	"./equation/icon-equation-bracket-17.svg": 2235,
	"./equation/icon-equation-bracket-18.svg": 2236,
	"./equation/icon-equation-bracket-19.svg": 2237,
	"./equation/icon-equation-bracket-2.svg": 2238,
	"./equation/icon-equation-bracket-20.svg": 2239,
	"./equation/icon-equation-bracket-21.svg": 2240,
	"./equation/icon-equation-bracket-22.svg": 2241,
	"./equation/icon-equation-bracket-23.svg": 2242,
	"./equation/icon-equation-bracket-24.svg": 2243,
	"./equation/icon-equation-bracket-25.svg": 2244,
	"./equation/icon-equation-bracket-26.svg": 2245,
	"./equation/icon-equation-bracket-27.svg": 2246,
	"./equation/icon-equation-bracket-28.svg": 2247,
	"./equation/icon-equation-bracket-29.svg": 2248,
	"./equation/icon-equation-bracket-3.svg": 2249,
	"./equation/icon-equation-bracket-30.svg": 2250,
	"./equation/icon-equation-bracket-31.svg": 2251,
	"./equation/icon-equation-bracket-32.svg": 2252,
	"./equation/icon-equation-bracket-33.svg": 2253,
	"./equation/icon-equation-bracket-34.svg": 2254,
	"./equation/icon-equation-bracket-35.svg": 2255,
	"./equation/icon-equation-bracket-36.svg": 2256,
	"./equation/icon-equation-bracket-37.svg": 2257,
	"./equation/icon-equation-bracket-4.svg": 2258,
	"./equation/icon-equation-bracket-5.svg": 2259,
	"./equation/icon-equation-bracket-6.svg": 2260,
	"./equation/icon-equation-bracket-7.svg": 2261,
	"./equation/icon-equation-bracket-8.svg": 2262,
	"./equation/icon-equation-bracket-9.svg": 2263,
	"./equation/icon-equation-bracket.svg": 2264,
	"./equation/icon-equation-caps-lock-2.svg": 2265,
	"./equation/icon-equation-caps-lock.svg": 2266,
	"./equation/icon-equation-fraction-1.svg": 2267,
	"./equation/icon-equation-fraction-2.svg": 2268,
	"./equation/icon-equation-fraction-3.svg": 2269,
	"./equation/icon-equation-fraction-4.svg": 2270,
	"./equation/icon-equation-fraction-5.svg": 2271,
	"./equation/icon-equation-fraction-6.svg": 2272,
	"./equation/icon-equation-fraction-7.svg": 2273,
	"./equation/icon-equation-fraction-8.svg": 2274,
	"./equation/icon-equation-fraction.svg": 2275,
	"./equation/icon-equation-function-1.svg": 2276,
	"./equation/icon-equation-function-10.svg": 2277,
	"./equation/icon-equation-function-11.svg": 2278,
	"./equation/icon-equation-function-12.svg": 2279,
	"./equation/icon-equation-function-13.svg": 2280,
	"./equation/icon-equation-function-14.svg": 2281,
	"./equation/icon-equation-function-15.svg": 2282,
	"./equation/icon-equation-function-16.svg": 2283,
	"./equation/icon-equation-function-2.svg": 2284,
	"./equation/icon-equation-function-3.svg": 2285,
	"./equation/icon-equation-function-4.svg": 2286,
	"./equation/icon-equation-function-5.svg": 2287,
	"./equation/icon-equation-function-6.svg": 2288,
	"./equation/icon-equation-function-7.svg": 2289,
	"./equation/icon-equation-function-8.svg": 2290,
	"./equation/icon-equation-function-9.svg": 2291,
	"./equation/icon-equation-function.svg": 2292,
	"./equation/icon-equation-integral-1.svg": 2293,
	"./equation/icon-equation-integral-10.svg": 2294,
	"./equation/icon-equation-integral-11.svg": 2295,
	"./equation/icon-equation-integral-12.svg": 2296,
	"./equation/icon-equation-integral-13.svg": 2297,
	"./equation/icon-equation-integral-14.svg": 2298,
	"./equation/icon-equation-integral-15.svg": 2299,
	"./equation/icon-equation-integral-16.svg": 2300,
	"./equation/icon-equation-integral-17.svg": 2301,
	"./equation/icon-equation-integral-2.svg": 2302,
	"./equation/icon-equation-integral-3.svg": 2303,
	"./equation/icon-equation-integral-4.svg": 2304,
	"./equation/icon-equation-integral-5.svg": 2305,
	"./equation/icon-equation-integral-6.svg": 2306,
	"./equation/icon-equation-integral-7.svg": 2307,
	"./equation/icon-equation-integral-8.svg": 2308,
	"./equation/icon-equation-integral-9.svg": 2309,
	"./equation/icon-equation-integral.svg": 2310,
	"./equation/icon-equation-large-operator-1.svg": 2311,
	"./equation/icon-equation-large-operator-2.svg": 2312,
	"./equation/icon-equation-large-operator-3.svg": 2313,
	"./equation/icon-equation-large-operator-4.svg": 2314,
	"./equation/icon-equation-large-operator-5.svg": 2315,
	"./equation/icon-equation-large-operator-6.svg": 2316,
	"./equation/icon-equation-large-operator.svg": 2317,
	"./equation/icon-equation-limit-1.svg": 2318,
	"./equation/icon-equation-limit-2.svg": 2319,
	"./equation/icon-equation-limit-3.svg": 2320,
	"./equation/icon-equation-limit-4.svg": 2321,
	"./equation/icon-equation-limit-5.svg": 2322,
	"./equation/icon-equation-limit-6.svg": 2323,
	"./equation/icon-equation-limit-7.svg": 2324,
	"./equation/icon-equation-limit.svg": 2325,
	"./equation/icon-equation-matrix-1.svg": 2326,
	"./equation/icon-equation-matrix-2.svg": 2327,
	"./equation/icon-equation-matrix-3.svg": 2328,
	"./equation/icon-equation-matrix-4.svg": 2329,
	"./equation/icon-equation-matrix-5.svg": 2330,
	"./equation/icon-equation-matrix-6.svg": 2331,
	"./equation/icon-equation-matrix.svg": 2332,
	"./equation/icon-equation-numbers.svg": 2333,
	"./equation/icon-equation-operator-1.svg": 2334,
	"./equation/icon-equation-operator-10.svg": 2335,
	"./equation/icon-equation-operator-11.svg": 2336,
	"./equation/icon-equation-operator-12.svg": 2337,
	"./equation/icon-equation-operator-13.svg": 2338,
	"./equation/icon-equation-operator-14.svg": 2339,
	"./equation/icon-equation-operator-15.svg": 2340,
	"./equation/icon-equation-operator-16.svg": 2341,
	"./equation/icon-equation-operator-17.svg": 2342,
	"./equation/icon-equation-operator-18.svg": 2343,
	"./equation/icon-equation-operator-19.svg": 2344,
	"./equation/icon-equation-operator-2.svg": 2345,
	"./equation/icon-equation-operator-3.svg": 2346,
	"./equation/icon-equation-operator-4.svg": 2347,
	"./equation/icon-equation-operator-5.svg": 2348,
	"./equation/icon-equation-operator-6.svg": 2349,
	"./equation/icon-equation-operator-7.svg": 2350,
	"./equation/icon-equation-operator-8.svg": 2351,
	"./equation/icon-equation-operator-9.svg": 2352,
	"./equation/icon-equation-operator.svg": 2353,
	"./equation/icon-equation-radical-1.svg": 2354,
	"./equation/icon-equation-radical-2.svg": 2355,
	"./equation/icon-equation-radical.svg": 2356,
	"./equation/icon-equation-script-1.svg": 2357,
	"./equation/icon-equation-script-2.svg": 2358,
	"./equation/icon-equation-script-3.svg": 2359,
	"./equation/icon-equation-script-4.svg": 2360,
	"./equation/icon-equation-script.svg": 2361,
	"./equation/icon-equation-symbol-1.svg": 2362,
	"./equation/icon-equation-symbol-10.svg": 2363,
	"./equation/icon-equation-symbol-100.svg": 2364,
	"./equation/icon-equation-symbol-101.svg": 2365,
	"./equation/icon-equation-symbol-102.svg": 2366,
	"./equation/icon-equation-symbol-103.svg": 2367,
	"./equation/icon-equation-symbol-104.svg": 2368,
	"./equation/icon-equation-symbol-105.svg": 2369,
	"./equation/icon-equation-symbol-106.svg": 2370,
	"./equation/icon-equation-symbol-107.svg": 2371,
	"./equation/icon-equation-symbol-108.svg": 2372,
	"./equation/icon-equation-symbol-109.svg": 2373,
	"./equation/icon-equation-symbol-11.svg": 2374,
	"./equation/icon-equation-symbol-110.svg": 2375,
	"./equation/icon-equation-symbol-111.svg": 2376,
	"./equation/icon-equation-symbol-112.svg": 2377,
	"./equation/icon-equation-symbol-113.svg": 2378,
	"./equation/icon-equation-symbol-114.svg": 2379,
	"./equation/icon-equation-symbol-115.svg": 2380,
	"./equation/icon-equation-symbol-116.svg": 2381,
	"./equation/icon-equation-symbol-117.svg": 2382,
	"./equation/icon-equation-symbol-118.svg": 2383,
	"./equation/icon-equation-symbol-119.svg": 2384,
	"./equation/icon-equation-symbol-12.svg": 2385,
	"./equation/icon-equation-symbol-120.svg": 2386,
	"./equation/icon-equation-symbol-121.svg": 2387,
	"./equation/icon-equation-symbol-122.svg": 2388,
	"./equation/icon-equation-symbol-123.svg": 2389,
	"./equation/icon-equation-symbol-124.svg": 2390,
	"./equation/icon-equation-symbol-125.svg": 2391,
	"./equation/icon-equation-symbol-126.svg": 2392,
	"./equation/icon-equation-symbol-127.svg": 2393,
	"./equation/icon-equation-symbol-128.svg": 2394,
	"./equation/icon-equation-symbol-129.svg": 2395,
	"./equation/icon-equation-symbol-13.svg": 2396,
	"./equation/icon-equation-symbol-130.svg": 2397,
	"./equation/icon-equation-symbol-131.svg": 2398,
	"./equation/icon-equation-symbol-132.svg": 2399,
	"./equation/icon-equation-symbol-133.svg": 2400,
	"./equation/icon-equation-symbol-134.svg": 2401,
	"./equation/icon-equation-symbol-135.svg": 2402,
	"./equation/icon-equation-symbol-136.svg": 2403,
	"./equation/icon-equation-symbol-137.svg": 2404,
	"./equation/icon-equation-symbol-138.svg": 2405,
	"./equation/icon-equation-symbol-139.svg": 2406,
	"./equation/icon-equation-symbol-14.svg": 2407,
	"./equation/icon-equation-symbol-140.svg": 2408,
	"./equation/icon-equation-symbol-141.svg": 2409,
	"./equation/icon-equation-symbol-142.svg": 2410,
	"./equation/icon-equation-symbol-143.svg": 2411,
	"./equation/icon-equation-symbol-144.svg": 2412,
	"./equation/icon-equation-symbol-145.svg": 2413,
	"./equation/icon-equation-symbol-146.svg": 2414,
	"./equation/icon-equation-symbol-147.svg": 2415,
	"./equation/icon-equation-symbol-148.svg": 2416,
	"./equation/icon-equation-symbol-149.svg": 2417,
	"./equation/icon-equation-symbol-15.svg": 2418,
	"./equation/icon-equation-symbol-150.svg": 2419,
	"./equation/icon-equation-symbol-151.svg": 2420,
	"./equation/icon-equation-symbol-152.svg": 2421,
	"./equation/icon-equation-symbol-153.svg": 2422,
	"./equation/icon-equation-symbol-154.svg": 2423,
	"./equation/icon-equation-symbol-155.svg": 2424,
	"./equation/icon-equation-symbol-156.svg": 2425,
	"./equation/icon-equation-symbol-157.svg": 2426,
	"./equation/icon-equation-symbol-158.svg": 2427,
	"./equation/icon-equation-symbol-159.svg": 2428,
	"./equation/icon-equation-symbol-16.svg": 2429,
	"./equation/icon-equation-symbol-160.svg": 2430,
	"./equation/icon-equation-symbol-161.svg": 2431,
	"./equation/icon-equation-symbol-162.svg": 2432,
	"./equation/icon-equation-symbol-163.svg": 2433,
	"./equation/icon-equation-symbol-164.svg": 2434,
	"./equation/icon-equation-symbol-165.svg": 2435,
	"./equation/icon-equation-symbol-166.svg": 2436,
	"./equation/icon-equation-symbol-167.svg": 2437,
	"./equation/icon-equation-symbol-168.svg": 2438,
	"./equation/icon-equation-symbol-169.svg": 2439,
	"./equation/icon-equation-symbol-17.svg": 2440,
	"./equation/icon-equation-symbol-170.svg": 2441,
	"./equation/icon-equation-symbol-171.svg": 2442,
	"./equation/icon-equation-symbol-172.svg": 2443,
	"./equation/icon-equation-symbol-173.svg": 2444,
	"./equation/icon-equation-symbol-174.svg": 2445,
	"./equation/icon-equation-symbol-175.svg": 2446,
	"./equation/icon-equation-symbol-176.svg": 2447,
	"./equation/icon-equation-symbol-177.svg": 2448,
	"./equation/icon-equation-symbol-178.svg": 2449,
	"./equation/icon-equation-symbol-179.svg": 2450,
	"./equation/icon-equation-symbol-18.svg": 2451,
	"./equation/icon-equation-symbol-180.svg": 2452,
	"./equation/icon-equation-symbol-181.svg": 2453,
	"./equation/icon-equation-symbol-182.svg": 2454,
	"./equation/icon-equation-symbol-183.svg": 2455,
	"./equation/icon-equation-symbol-184.svg": 2456,
	"./equation/icon-equation-symbol-185.svg": 2457,
	"./equation/icon-equation-symbol-186.svg": 2458,
	"./equation/icon-equation-symbol-187.svg": 2459,
	"./equation/icon-equation-symbol-188.svg": 2460,
	"./equation/icon-equation-symbol-189.svg": 2461,
	"./equation/icon-equation-symbol-19.svg": 2462,
	"./equation/icon-equation-symbol-190.svg": 2463,
	"./equation/icon-equation-symbol-191.svg": 2464,
	"./equation/icon-equation-symbol-192.svg": 2465,
	"./equation/icon-equation-symbol-193.svg": 2466,
	"./equation/icon-equation-symbol-194.svg": 2467,
	"./equation/icon-equation-symbol-195.svg": 2468,
	"./equation/icon-equation-symbol-196.svg": 2469,
	"./equation/icon-equation-symbol-197.svg": 2470,
	"./equation/icon-equation-symbol-198.svg": 2471,
	"./equation/icon-equation-symbol-199.svg": 2472,
	"./equation/icon-equation-symbol-2.svg": 2473,
	"./equation/icon-equation-symbol-20.svg": 2474,
	"./equation/icon-equation-symbol-200.svg": 2475,
	"./equation/icon-equation-symbol-201.svg": 2476,
	"./equation/icon-equation-symbol-202.svg": 2477,
	"./equation/icon-equation-symbol-203.svg": 2478,
	"./equation/icon-equation-symbol-204.svg": 2479,
	"./equation/icon-equation-symbol-205.svg": 2480,
	"./equation/icon-equation-symbol-206.svg": 2481,
	"./equation/icon-equation-symbol-207.svg": 2482,
	"./equation/icon-equation-symbol-208.svg": 2483,
	"./equation/icon-equation-symbol-209.svg": 2484,
	"./equation/icon-equation-symbol-21.svg": 2485,
	"./equation/icon-equation-symbol-210.svg": 2486,
	"./equation/icon-equation-symbol-211.svg": 2487,
	"./equation/icon-equation-symbol-212.svg": 2488,
	"./equation/icon-equation-symbol-213.svg": 2489,
	"./equation/icon-equation-symbol-214.svg": 2490,
	"./equation/icon-equation-symbol-215.svg": 2491,
	"./equation/icon-equation-symbol-216.svg": 2492,
	"./equation/icon-equation-symbol-217.svg": 2493,
	"./equation/icon-equation-symbol-218.svg": 2494,
	"./equation/icon-equation-symbol-219.svg": 2495,
	"./equation/icon-equation-symbol-22.svg": 2496,
	"./equation/icon-equation-symbol-220.svg": 2497,
	"./equation/icon-equation-symbol-221.svg": 2498,
	"./equation/icon-equation-symbol-222.svg": 2499,
	"./equation/icon-equation-symbol-223.svg": 2500,
	"./equation/icon-equation-symbol-224.svg": 2501,
	"./equation/icon-equation-symbol-225.svg": 2502,
	"./equation/icon-equation-symbol-226.svg": 2503,
	"./equation/icon-equation-symbol-227.svg": 2504,
	"./equation/icon-equation-symbol-228.svg": 2505,
	"./equation/icon-equation-symbol-229.svg": 2506,
	"./equation/icon-equation-symbol-23.svg": 2507,
	"./equation/icon-equation-symbol-230.svg": 2508,
	"./equation/icon-equation-symbol-231.svg": 2509,
	"./equation/icon-equation-symbol-232.svg": 2510,
	"./equation/icon-equation-symbol-233.svg": 2511,
	"./equation/icon-equation-symbol-234.svg": 2512,
	"./equation/icon-equation-symbol-235.svg": 2513,
	"./equation/icon-equation-symbol-236.svg": 2514,
	"./equation/icon-equation-symbol-237.svg": 2515,
	"./equation/icon-equation-symbol-238.svg": 2516,
	"./equation/icon-equation-symbol-239.svg": 2517,
	"./equation/icon-equation-symbol-24.svg": 2518,
	"./equation/icon-equation-symbol-240.svg": 2519,
	"./equation/icon-equation-symbol-241.svg": 2520,
	"./equation/icon-equation-symbol-242.svg": 2521,
	"./equation/icon-equation-symbol-243.svg": 2522,
	"./equation/icon-equation-symbol-244.svg": 2523,
	"./equation/icon-equation-symbol-245.svg": 2524,
	"./equation/icon-equation-symbol-246.svg": 2525,
	"./equation/icon-equation-symbol-247.svg": 2526,
	"./equation/icon-equation-symbol-248.svg": 2527,
	"./equation/icon-equation-symbol-249.svg": 2528,
	"./equation/icon-equation-symbol-25.svg": 2529,
	"./equation/icon-equation-symbol-250.svg": 2530,
	"./equation/icon-equation-symbol-251.svg": 2531,
	"./equation/icon-equation-symbol-252.svg": 2532,
	"./equation/icon-equation-symbol-253.svg": 2533,
	"./equation/icon-equation-symbol-254.svg": 2534,
	"./equation/icon-equation-symbol-255.svg": 2535,
	"./equation/icon-equation-symbol-256.svg": 2536,
	"./equation/icon-equation-symbol-257.svg": 2537,
	"./equation/icon-equation-symbol-258.svg": 2538,
	"./equation/icon-equation-symbol-259.svg": 2539,
	"./equation/icon-equation-symbol-26.svg": 2540,
	"./equation/icon-equation-symbol-260.svg": 2541,
	"./equation/icon-equation-symbol-261.svg": 2542,
	"./equation/icon-equation-symbol-262.svg": 2543,
	"./equation/icon-equation-symbol-263.svg": 2544,
	"./equation/icon-equation-symbol-264.svg": 2545,
	"./equation/icon-equation-symbol-265.svg": 2546,
	"./equation/icon-equation-symbol-266.svg": 2547,
	"./equation/icon-equation-symbol-267.svg": 2548,
	"./equation/icon-equation-symbol-268.svg": 2549,
	"./equation/icon-equation-symbol-269.svg": 2550,
	"./equation/icon-equation-symbol-27.svg": 2551,
	"./equation/icon-equation-symbol-270.svg": 2552,
	"./equation/icon-equation-symbol-271.svg": 2553,
	"./equation/icon-equation-symbol-272.svg": 2554,
	"./equation/icon-equation-symbol-273.svg": 2555,
	"./equation/icon-equation-symbol-274.svg": 2556,
	"./equation/icon-equation-symbol-275.svg": 2557,
	"./equation/icon-equation-symbol-276.svg": 2558,
	"./equation/icon-equation-symbol-28.svg": 2559,
	"./equation/icon-equation-symbol-29.svg": 2560,
	"./equation/icon-equation-symbol-3.svg": 2561,
	"./equation/icon-equation-symbol-30.svg": 2562,
	"./equation/icon-equation-symbol-31.svg": 2563,
	"./equation/icon-equation-symbol-32.svg": 2564,
	"./equation/icon-equation-symbol-33.svg": 2565,
	"./equation/icon-equation-symbol-34.svg": 2566,
	"./equation/icon-equation-symbol-35.svg": 2567,
	"./equation/icon-equation-symbol-36.svg": 2568,
	"./equation/icon-equation-symbol-37.svg": 2569,
	"./equation/icon-equation-symbol-38.svg": 2570,
	"./equation/icon-equation-symbol-39.svg": 2571,
	"./equation/icon-equation-symbol-4.svg": 2572,
	"./equation/icon-equation-symbol-40.svg": 2573,
	"./equation/icon-equation-symbol-41.svg": 2574,
	"./equation/icon-equation-symbol-42.svg": 2575,
	"./equation/icon-equation-symbol-43.svg": 2576,
	"./equation/icon-equation-symbol-44.svg": 2577,
	"./equation/icon-equation-symbol-45.svg": 2578,
	"./equation/icon-equation-symbol-46.svg": 2579,
	"./equation/icon-equation-symbol-47.svg": 2580,
	"./equation/icon-equation-symbol-48.svg": 2581,
	"./equation/icon-equation-symbol-49.svg": 2582,
	"./equation/icon-equation-symbol-5.svg": 2583,
	"./equation/icon-equation-symbol-50.svg": 2584,
	"./equation/icon-equation-symbol-51.svg": 2585,
	"./equation/icon-equation-symbol-52.svg": 2586,
	"./equation/icon-equation-symbol-53.svg": 2587,
	"./equation/icon-equation-symbol-54.svg": 2588,
	"./equation/icon-equation-symbol-55.svg": 2589,
	"./equation/icon-equation-symbol-56.svg": 2590,
	"./equation/icon-equation-symbol-57.svg": 2591,
	"./equation/icon-equation-symbol-58.svg": 2592,
	"./equation/icon-equation-symbol-59.svg": 2593,
	"./equation/icon-equation-symbol-6.svg": 2594,
	"./equation/icon-equation-symbol-60.svg": 2595,
	"./equation/icon-equation-symbol-61.svg": 2596,
	"./equation/icon-equation-symbol-62.svg": 2597,
	"./equation/icon-equation-symbol-63.svg": 2598,
	"./equation/icon-equation-symbol-64.svg": 2599,
	"./equation/icon-equation-symbol-65.svg": 2600,
	"./equation/icon-equation-symbol-66.svg": 2601,
	"./equation/icon-equation-symbol-67.svg": 2602,
	"./equation/icon-equation-symbol-68.svg": 2603,
	"./equation/icon-equation-symbol-69.svg": 2604,
	"./equation/icon-equation-symbol-7.svg": 2605,
	"./equation/icon-equation-symbol-70.svg": 2606,
	"./equation/icon-equation-symbol-71.svg": 2607,
	"./equation/icon-equation-symbol-72.svg": 2608,
	"./equation/icon-equation-symbol-73.svg": 2609,
	"./equation/icon-equation-symbol-74.svg": 2610,
	"./equation/icon-equation-symbol-75.svg": 2611,
	"./equation/icon-equation-symbol-76.svg": 2612,
	"./equation/icon-equation-symbol-77.svg": 2613,
	"./equation/icon-equation-symbol-78.svg": 2614,
	"./equation/icon-equation-symbol-79.svg": 2615,
	"./equation/icon-equation-symbol-8.svg": 2616,
	"./equation/icon-equation-symbol-80.svg": 2617,
	"./equation/icon-equation-symbol-81.svg": 2618,
	"./equation/icon-equation-symbol-82.svg": 2619,
	"./equation/icon-equation-symbol-83.svg": 2620,
	"./equation/icon-equation-symbol-84.svg": 2621,
	"./equation/icon-equation-symbol-85.svg": 2622,
	"./equation/icon-equation-symbol-86.svg": 2623,
	"./equation/icon-equation-symbol-87.svg": 2624,
	"./equation/icon-equation-symbol-88.svg": 2625,
	"./equation/icon-equation-symbol-89.svg": 2626,
	"./equation/icon-equation-symbol-9.svg": 2627,
	"./equation/icon-equation-symbol-90.svg": 2628,
	"./equation/icon-equation-symbol-91.svg": 2629,
	"./equation/icon-equation-symbol-92.svg": 2630,
	"./equation/icon-equation-symbol-93.svg": 2631,
	"./equation/icon-equation-symbol-94.svg": 2632,
	"./equation/icon-equation-symbol-95.svg": 2633,
	"./equation/icon-equation-symbol-96.svg": 2634,
	"./equation/icon-equation-symbol-97.svg": 2635,
	"./equation/icon-equation-symbol-98.svg": 2636,
	"./equation/icon-equation-symbol-99.svg": 2637,
	"./equation/icon-equation-symbol.svg": 2638,
	"./equation/icon-menu-accent.svg": 2721,
	"./equation/icon-menu-arrows.svg": 2722,
	"./equation/icon-menu-basic-math.svg": 2723,
	"./equation/icon-menu-bracket.svg": 2724,
	"./equation/icon-menu-fraction.svg": 2725,
	"./equation/icon-menu-function.svg": 2726,
	"./equation/icon-menu-geometry.svg": 2727,
	"./equation/icon-menu-greek.svg": 2728,
	"./equation/icon-menu-integral.svg": 2729,
	"./equation/icon-menu-large-operator.svg": 2730,
	"./equation/icon-menu-letter-like.svg": 2731,
	"./equation/icon-menu-letters.svg": 2732,
	"./equation/icon-menu-limit.svg": 2733,
	"./equation/icon-menu-matrix.svg": 2734,
	"./equation/icon-menu-operator.svg": 2735,
	"./equation/icon-menu-operators.svg": 2736,
	"./equation/icon-menu-radical.svg": 2737,
	"./equation/icon-menu-script.svg": 2738,
	"./equation/icon-menu-text.svg": 2739,
	"./exams/arrow.svg": 1738,
	"./exams/correct-answer.svg": 2740,
	"./exams/excel.svg": 3105,
	"./exams/icon-star.svg": 3106,
	"./exams/incorrect-answer.svg": 2741,
	"./exams/pdf.svg": 3107,
	"./exams/python.svg": 3108,
	"./exams/unknown.svg": 1680,
	"./exercise/blank-typing.svg": 1991,
	"./exercise/blank.svg": 1992,
	"./exercise/category.svg": 1993,
	"./exercise/matrix.svg": 1994,
	"./exercise/multiple-choice.svg": 1995,
	"./exercise/order.svg": 1996,
	"./exercise/single-choice.svg": 1997,
	"./exercise/true-false.svg": 1998,
	"./eye-closed.svg": 3109,
	"./eye-opened.svg": 3110,
	"./eye.svg": 2742,
	"./fa/fa-icon-checked-blue.svg": 3111,
	"./flashcards/browse-deck.svg": 2095,
	"./flashcards/click-hand.svg": 2743,
	"./flashcards/load-arrow.svg": 2096,
	"./flashcards/reload-deck.svg": 2097,
	"./flashcards/restart-review.svg": 3112,
	"./flashcards/review-small-eye.svg": 2744,
	"./flashcards/send-result.svg": 2745,
	"./flashcards/take-test.svg": 2098,
	"./flashcards/white-left-arrow.svg": 2746,
	"./gfx-certificate-circle.svg": 3113,
	"./gfx-certificate-excel.svg": 3114,
	"./gfx-certificate-git.svg": 3115,
	"./gfx-certificate-powerbi.svg": 3116,
	"./gfx-certificate-python.svg": 3117,
	"./gfx-certificate-r.svg": 3118,
	"./gfx-certificate-tableau.svg": 3119,
	"./gfx-certificate-theory.svg": 3120,
	"./gfx-hats-left.svg": 3121,
	"./gfx-hats-right.svg": 3122,
	"./icon-404-lms-courses.svg": 2747,
	"./icon-404-lms-practice.svg": 2748,
	"./icon-404-lms-qa.svg": 2749,
	"./icon-admin-difficulty-0.svg": 1178,
	"./icon-admin-difficulty-1.svg": 1179,
	"./icon-admin-difficulty-2.svg": 1180,
	"./icon-admin-info.svg": 1181,
	"./icon-alert.svg": 2750,
	"./icon-arrow-back.svg": 512,
	"./icon-arrow-blue.svg": 2751,
	"./icon-arrow-down-resizable.svg": 1739,
	"./icon-arrow-down.svg": 1740,
	"./icon-arrow-dropdown-down.svg": 2639,
	"./icon-arrow-dropdown.svg": 2099,
	"./icon-arrow-expand.svg": 1638,
	"./icon-arrow-gray.svg": 2100,
	"./icon-arrow-left.svg": 753,
	"./icon-arrow-next.svg": 2101,
	"./icon-arrow-prev.svg": 2102,
	"./icon-arrow-right.svg": 1681,
	"./icon-arrow-up.svg": 1759,
	"./icon-arrow.svg": 1182,
	"./icon-assignment.svg": 2752,
	"./icon-audience-1.svg": 2103,
	"./icon-audience-2.svg": 2104,
	"./icon-audience-3.svg": 2105,
	"./icon-back.svg": 2073,
	"./icon-backspace.svg": 2640,
	"./icon-basket.svg": 2089,
	"./icon-bin.svg": 2106,
	"./icon-black-filled-arrow.svg": 2753,
	"./icon-bug.svg": 2641,
	"./icon-bulb.svg": 2754,
	"./icon-career-track.svg": 2107,
	"./icon-certificate.svg": 2108,
	"./icon-certificates.svg": 2755,
	"./icon-check-blue-bold.svg": 2756,
	"./icon-check-circle.svg": 1682,
	"./icon-check-extreme-fucsia.svg": 2757,
	"./icon-check-list.svg": 2758,
	"./icon-check-projects.svg": 1683,
	"./icon-check.svg": 2109,
	"./icon-checkbox.svg": 2759,
	"./icon-checked-accent-light-3.svg": 2760,
	"./icon-checked-bf.svg": 2761,
	"./icon-checked-blue.svg": 2762,
	"./icon-checked-cm.svg": 2763,
	"./icon-checked-ds-accent.svg": 2764,
	"./icon-checked-extreme-blue-2.svg": 2765,
	"./icon-checked-mw.svg": 2766,
	"./icon-checked-purple.svg": 2767,
	"./icon-checked-tyf.svg": 2768,
	"./icon-checked-yellow-bold.svg": 2769,
	"./icon-checked-yellow.svg": 2770,
	"./icon-checked.svg": 2771,
	"./icon-checkmark.svg": 2772,
	"./icon-circle-check.svg": 2773,
	"./icon-clear-filters.svg": 2774,
	"./icon-clock-colored.svg": 2775,
	"./icon-clock.svg": 2110,
	"./icon-close.svg": 486,
	"./icon-closemark.svg": 2776,
	"./icon-clp-trash.svg": 547,
	"./icon-code.svg": 2777,
	"./icon-colored-google.svg": 2778,
	"./icon-colored-linkedin-fill.svg": 2779,
	"./icon-comment.svg": 1741,
	"./icon-complete-program.svg": 2780,
	"./icon-completed.svg": 2781,
	"./icon-copy-text.svg": 2782,
	"./icon-copy.svg": 1999,
	"./icon-course-banner.svg": 2783,
	"./icon-course-content.svg": 2000,
	"./icon-course-exam-type.svg": 2784,
	"./icon-courses.svg": 2785,
	"./icon-curriculum-review-comment-resolved.svg": 2786,
	"./icon-curriculum-review-comment.svg": 2787,
	"./icon-curriculum-validation-error.svg": 2788,
	"./icon-description-type.svg": 2789,
	"./icon-difficulty-advanced-2.svg": 2074,
	"./icon-difficulty-advanced.svg": 2111,
	"./icon-difficulty-beginner-2.svg": 2075,
	"./icon-difficulty-beginner.svg": 2112,
	"./icon-difficulty-intermediate-2.svg": 2076,
	"./icon-difficulty-intermediate.svg": 2113,
	"./icon-down-arrow.svg": 2114,
	"./icon-download-arrow.svg": 2790,
	"./icon-download-sm.svg": 2791,
	"./icon-download.svg": 2792,
	"./icon-download2.svg": 2642,
	"./icon-drag-dots.svg": 2793,
	"./icon-editor-bold.svg": 2794,
	"./icon-editor-code.svg": 2795,
	"./icon-editor-codeblock.svg": 2796,
	"./icon-editor-emoji.svg": 2797,
	"./icon-editor-image.svg": 2798,
	"./icon-editor-italic.svg": 2799,
	"./icon-editor-link.svg": 2800,
	"./icon-editor-strike.svg": 2801,
	"./icon-empty-folder.svg": 2802,
	"./icon-enter.svg": 2643,
	"./icon-exam-clock.svg": 1654,
	"./icon-exam-download.svg": 2803,
	"./icon-exam-flag.svg": 1606,
	"./icon-exam-question-type.svg": 2804,
	"./icon-exam-question.svg": 1742,
	"./icon-exam-share-result.svg": 2805,
	"./icon-exam-summary-type.svg": 2806,
	"./icon-exam-warning.svg": 644,
	"./icon-exams-subtract.svg": 2644,
	"./icon-exclamation-red.svg": 1743,
	"./icon-exclamation.svg": 2645,
	"./icon-exercise-type.svg": 2807,
	"./icon-exit.svg": 2808,
	"./icon-facebook-white.svg": 2809,
	"./icon-facebook.svg": 2810,
	"./icon-faq-expand.svg": 593,
	"./icon-fb.svg": 2001,
	"./icon-film.svg": 2002,
	"./icon-filter-sort.svg": 1676,
	"./icon-filter.svg": 1674,
	"./icon-flashcards-arrow.svg": 2115,
	"./icon-header-back-arrow.svg": 2003,
	"./icon-help.svg": 2811,
	"./icon-home.svg": 2812,
	"./icon-info.svg": 510,
	"./icon-inlinecode.svg": 2813,
	"./icon-iphone.svg": 2004,
	"./icon-language.svg": 2116,
	"./icon-laptop.svg": 2005,
	"./icon-latex.svg": 2646,
	"./icon-learn.svg": 2117,
	"./icon-lesson-locked.svg": 2814,
	"./icon-lesson-text-type.svg": 2006,
	"./icon-lesson-type.svg": 2815,
	"./icon-library-badge-advanced.svg": 1744,
	"./icon-library-badge-beginner.svg": 1745,
	"./icon-library-badge-intermediate.svg": 1746,
	"./icon-lightbulb.svg": 1684,
	"./icon-link.svg": 2816,
	"./icon-linkedin-white.svg": 2817,
	"./icon-linkedin.svg": 2007,
	"./icon-locked.svg": 1614,
	"./icon-mail.svg": 495,
	"./icon-mathview.svg": 2647,
	"./icon-menu-arrow.svg": 2818,
	"./icon-menu-collapse.svg": 2648,
	"./icon-mobile-filter.svg": 2819,
	"./icon-monitor.svg": 2008,
	"./icon-newsfeed-comment.svg": 2820,
	"./icon-newsfeed-edit.svg": 2821,
	"./icon-newsfeed-learners.svg": 2822,
	"./icon-newsfeed-like.svg": 2823,
	"./icon-newsfeed-remove.svg": 2824,
	"./icon-newsfeed-report.svg": 2825,
	"./icon-newsfeed-snooze.svg": 2826,
	"./icon-newsfeed-trophy.svg": 2827,
	"./icon-notifications-bell.svg": 2828,
	"./icon-pencil-nofill.svg": 2829,
	"./icon-pencil-small-edit.svg": 2830,
	"./icon-pencil.svg": 2118,
	"./icon-people.svg": 1788,
	"./icon-photo.svg": 2831,
	"./icon-pin.svg": 1685,
	"./icon-play-active.svg": 2832,
	"./icon-play-circle.svg": 1789,
	"./icon-play.svg": 2833,
	"./icon-plus-gray-fill.svg": 754,
	"./icon-plus-in-square.svg": 1747,
	"./icon-plus.svg": 1748,
	"./icon-practice-exam-type.svg": 2834,
	"./icon-practice.svg": 2835,
	"./icon-price.svg": 2119,
	"./icon-pricing-arrow-down.svg": 2120,
	"./icon-pricing-badge.svg": 2121,
	"./icon-pricing-check.svg": 2122,
	"./icon-project-content.svg": 2123,
	"./icon-project-featured.svg": 2124,
	"./icon-project-files.svg": 2077,
	"./icon-project-related-courses.svg": 2125,
	"./icon-project-solution-files.svg": 2126,
	"./icon-project-topics.svg": 2127,
	"./icon-project-type.svg": 2836,
	"./icon-project.svg": 2837,
	"./icon-qa-ask.svg": 2838,
	"./icon-qa-delete-answer.svg": 2839,
	"./icon-qa-diamond.svg": 2840,
	"./icon-qa-edit-answer.svg": 2841,
	"./icon-qa-ellipsis-v.svg": 2128,
	"./icon-qa-follow.svg": 2129,
	"./icon-qa-followed.svg": 2842,
	"./icon-qa-glasses.svg": 2843,
	"./icon-qa-magnifier.svg": 2844,
	"./icon-qa-mark.svg": 2130,
	"./icon-qa-report.svg": 2845,
	"./icon-qa-resolve.svg": 2131,
	"./icon-qa-unassign.svg": 2132,
	"./icon-qa.svg": 2846,
	"./icon-question-mark.svg": 1749,
	"./icon-question.svg": 606,
	"./icon-quiz.svg": 2847,
	"./icon-quote-testimonials.svg": 608,
	"./icon-quote.svg": 2133,
	"./icon-rating-star.svg": 2848,
	"./icon-remaining-time.svg": 2849,
	"./icon-replay.svg": 2850,
	"./icon-reset-2.svg": 2134,
	"./icon-reset.svg": 2009,
	"./icon-resources.svg": 2851,
	"./icon-review-comments.svg": 2852,
	"./icon-review-indicator.svg": 1617,
	"./icon-review-star.svg": 2135,
	"./icon-reviewed-comments.svg": 2853,
	"./icon-scroll-top.svg": 2854,
	"./icon-search-assignment.svg": 2855,
	"./icon-search-certificate.svg": 2856,
	"./icon-search-code.svg": 2857,
	"./icon-search-course-notes.svg": 2858,
	"./icon-search-course.svg": 2859,
	"./icon-search-dataset.svg": 2860,
	"./icon-search-lesson.svg": 2861,
	"./icon-search-progress-0.svg": 2862,
	"./icon-search-progress-1.svg": 2863,
	"./icon-search-progress-2.svg": 2864,
	"./icon-search-project.svg": 2865,
	"./icon-search-questions.svg": 2866,
	"./icon-search-quiz.svg": 2867,
	"./icon-search-resource.svg": 2868,
	"./icon-search-time.svg": 2869,
	"./icon-search.svg": 568,
	"./icon-section-locked.svg": 2870,
	"./icon-send.svg": 2871,
	"./icon-share-score.svg": 2872,
	"./icon-share.svg": 2136,
	"./icon-share2.svg": 2873,
	"./icon-shield.svg": 2874,
	"./icon-shuffle.svg": 2137,
	"./icon-site-linkedin.svg": 2010,
	"./icon-site-search.svg": 2875,
	"./icon-site-twitter.svg": 2876,
	"./icon-snooze.svg": 2877,
	"./icon-sort.svg": 1675,
	"./icon-star.svg": 2878,
	"./icon-stock-down.svg": 2879,
	"./icon-stock-up.svg": 2880,
	"./icon-subtract-unlocked.svg": 2881,
	"./icon-subtract.svg": 2882,
	"./icon-sync.svg": 2078,
	"./icon-text-based-exclamation.svg": 1750,
	"./icon-text-based-play.svg": 2011,
	"./icon-text-based-question.svg": 2883,
	"./icon-text-lesson-type.svg": 2884,
	"./icon-tinymce-bold.svg": 2885,
	"./icon-tinymce-code.svg": 2886,
	"./icon-tinymce-codeblock.svg": 2887,
	"./icon-tinymce-emoji.svg": 2888,
	"./icon-tinymce-italic.svg": 2889,
	"./icon-tinymce-link.svg": 2890,
	"./icon-tinymce-strike.svg": 2891,
	"./icon-tinymce-submit.svg": 2892,
	"./icon-trash.svg": 1677,
	"./icon-trustpilot.svg": 1790,
	"./icon-twitter.svg": 2012,
	"./icon-up-arrow.svg": 1686,
	"./icon-vertical-dots.svg": 2893,
	"./icon-video-cc.svg": 2894,
	"./icon-video-full-screen.svg": 2895,
	"./icon-video-mute.svg": 2896,
	"./icon-video-pause.svg": 2897,
	"./icon-video-play.svg": 2898,
	"./icon-video-rewind.svg": 2899,
	"./icon-video-settings.svg": 2900,
	"./icon-video-transcript.svg": 2901,
	"./icon-video-volume.svg": 2902,
	"./icon-warning-gray.svg": 2013,
	"./icon-warning.svg": 1687,
	"./icon-x.svg": 2903,
	"./icon-youtube.svg": 2904,
	"./linkedin-logo.svg": 3123,
	"./loading-spinner.svg": 2014,
	"./medal.svg": 1733,
	"./minus-icon.svg": 2905,
	"./money-back-guarantee.svg": 2138,
	"./offline.svg": 2139,
	"./player/cc.svg": 3124,
	"./player/fullscreen.svg": 3125,
	"./player/mute.svg": 3126,
	"./player/pause.svg": 3127,
	"./player/play-v2-sm.svg": 3128,
	"./player/play-v2.svg": 3129,
	"./player/play.svg": 3130,
	"./player/polygon.svg": 3131,
	"./player/rewind.svg": 3132,
	"./player/settings.svg": 3133,
	"./player/volume.svg": 3134,
	"./plus-icon.svg": 2906,
	"./projects-guided-unguided.svg": 3135,
	"./projects-instruction.svg": 3136,
	"./projects-quiz.svg": 3137,
	"./rounded-quotes-big.svg": 2907,
	"./rounded-quotes.svg": 3138,
	"./saved.svg": 2140,
	"./select-arrow.svg": 3139,
	"./select-dropdown-arrow.svg": 3140,
	"./signatures/company-linkedin.svg": 3141,
	"./signatures/company-youtube.svg": 3142,
	"./small-icon-download.svg": 2141,
	"./sql.svg": 3143,
	"./tech-excel.svg": 2142,
	"./tech-git.svg": 2143,
	"./tech-google-sheets.svg": 2144,
	"./tech-gray-chatgpt.svg": 1154,
	"./tech-gray-excel.svg": 1155,
	"./tech-gray-git.svg": 1156,
	"./tech-gray-google-sheets.svg": 1157,
	"./tech-gray-jupyter.svg": 1158,
	"./tech-gray-multiple.svg": 1159,
	"./tech-gray-other.svg": 1160,
	"./tech-gray-powerbi.svg": 1161,
	"./tech-gray-python.svg": 1162,
	"./tech-gray-r.svg": 1163,
	"./tech-gray-sql.svg": 1164,
	"./tech-gray-tableau.svg": 1165,
	"./tech-gray-theory.svg": 1166,
	"./tech-powerbi.svg": 2145,
	"./tech-python (2).svg": 2146,
	"./tech-python.svg": 2147,
	"./tech-r.svg": 2148,
	"./tech-responsive-artificial-intelligence.svg": 526,
	"./tech-responsive-chatgpt.svg": 553,
	"./tech-responsive-data.svg": 554,
	"./tech-responsive-excel.svg": 555,
	"./tech-responsive-git.svg": 556,
	"./tech-responsive-google-sheets.svg": 557,
	"./tech-responsive-jupyter.svg": 558,
	"./tech-responsive-langchain.svg": 559,
	"./tech-responsive-multiple.svg": 560,
	"./tech-responsive-powerbi.svg": 561,
	"./tech-responsive-powerpoint.svg": 562,
	"./tech-responsive-python.svg": 563,
	"./tech-responsive-r.svg": 564,
	"./tech-responsive-sql.svg": 565,
	"./tech-responsive-tableau.svg": 566,
	"./tech-responsive-theory.svg": 567,
	"./tech-sql.svg": 2149,
	"./tech-tableau.svg": 2150,
	"./tech-theory.svg": 2151,
	"./tightly-arrow.svg": 3144,
	"./topic-responsive-business analytics.svg": 3145,
	"./topic-responsive-business-analytics.svg": 3146,
	"./topic-responsive-career-development.svg": 3147,
	"./topic-responsive-data-analysis.svg": 3148,
	"./topic-responsive-data-processing.svg": 3149,
	"./topic-responsive-data-science.svg": 3150,
	"./topic-responsive-data-visualization.svg": 3151,
	"./topic-responsive-deep-learning.svg": 3152,
	"./topic-responsive-financial-analysis.svg": 3153,
	"./topic-responsive-machine-learning.svg": 3154,
	"./topic-responsive-mathematics.svg": 3155,
	"./topic-responsive-programming.svg": 3156,
	"./vector.svg": 3157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3080;